import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import React from "react";
import { useCallback } from "react";
import { FaArrowLeft, FaFacebookF } from "react-icons/fa";

interface P {
  username: string;
  goBack: () => void;
  onUsernameChange: (value: string) => void;
  onSubmit: () => void;
  onFacebookLoginClick: () => void;
  onGoogleLoginSucces: (credentials: string) => void;
}

export const ChatLogin = ({
  username,
  goBack,
  onUsernameChange,
  onSubmit,
  onFacebookLoginClick,
  onGoogleLoginSucces
}: P) => {
  const handleUsernameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onUsernameChange(e.target.value);
    },
    [onUsernameChange]
  );
  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  const handleGoogleLoginSucces = useCallback(
    (res: CredentialResponse) => {
      if (res.credential) {
        onGoogleLoginSucces(res.credential);
      }
    },
    [onGoogleLoginSucces]
  );
  return (
    <div className="flex flex-col w-full items-center">
      <div className="absolute top-2 left-2 cursor-pointer" onClick={goBack}>
        <FaArrowLeft />
      </div>
      <form className="w-full flex flex-col items-center mt-4" onSubmit={handleSubmit}>
        <h2 className="text-2xl font-bold">Salutari</h2>
        <h2 className="text-xl">Cu ce nume vrei sa intri?</h2>
        <input
          className="mt-4 p-2"
          placeholder="Introdu un nume de utilizator"
          value={username}
          onChange={handleUsernameChange}
          type="text"></input>
        {/* {loggedIn && (
          <div
            style={{ visibility: username ? "visible" : "hidden" }}
            className="flex flex-col items-center">
            <div className="mt-2">Te-ai conectat cu {loggedIn}.</div>
            <div className="mt-2">
              <button
                className="bg-a-red px-4 py-2 shadow-md text-white"
                type="button"
                onClick={onLogoutClick}>
                Deconecteaza de la {loggedIn}
              </button>
            </div>

            <div style={{ visibility: username ? "visible" : "hidden" }} className="mt-2">
              <button className="bg-a-red px-4 py-2 shadow-md text-white" type="submit">
                Intra in chat
              </button>
            </div>
          </div>
        )} */}
      </form>

      <div className="max-w-[80%] flex flex-col justify-center items-center mt-6 relative">
        {!username && <div className="absolute w-full h-full bg-transparent-gray !z-[999]" />}
        <div className="w-52">
          <div
            onClick={onFacebookLoginClick}
            className="bg-blue-500 px-4 py-2 flex flex-row items-center justify-center w-full text-white cursor-pointer">
            <FaFacebookF className="relative bottom-[0.3px]" color="white" />{" "}
            <span className="text-[12px]">Conecteaza-te cu Facebook</span>
          </div>
        </div>
        <div className="mt-2">
          <GoogleLogin
            width="100%"
            ux_mode="popup"
            type="standard"
            locale="ro_RO"
            useOneTap={false}
            onSuccess={handleGoogleLoginSucces}
          />
        </div>
      </div>
    </div>
  );
};
